import { useLocalStorage } from '@flipster/react/misc/state/use-local-storage';

export function useOrderTutorialV2FeatureTooltip() {
  return useLocalStorage({
    key: 'flipster.configs.v1.order_tutorial_v2_feature_tooltip',
    defaultValue: true,
  });
}
